import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from 'react-router-dom';
import './ResetPassword.css';

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.registerSuccess) {
      alert('Seu cadastro foi criado com sucesso, acesse nossa plataforma com seus dados.');
    }
  }, [location]);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if ((password !== confirmPassword) || (password.length < 6 || confirmPassword.length < 6)) {
      alert("Verifique as senhas digitadas, elas devem ser iguais e ter mais que 6 caracters.");
      return;
    }

    try {
      const response = await axios.post(apiUrl+'reset-password', {
        token: new URLSearchParams(location.search).get('token'),
        password,
      });
      alert("Senha redefinida com sucesso!");
      navigate('/')
    } catch (err) {
      alert("Erro ao redefinir senha! Tente novamente mais tarde.");
      setError("Erro de redefinição de senha: " + (err.response ? err.response.data.message : err.message));
    }
  };

  return (
    <div className="reset-password-page login-container">
      <div className="login-card">
        <h2>Redefinir senha Preparate Questões</h2>
        <form onSubmit={handleResetPassword}>
          <div className="input-group">
            <label>Nova senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua nova senha"
            />
          </div>
          <div className="input-group">
            <label>Confirme a nova senha</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirme sua nova senha"
            />
          </div>
          <div>
            <button type="submit" className="btn-submit">Redefinir senha</button>
            <div></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;